import { render, staticRenderFns } from "./Spacer.html?vue&type=template&id=78f7a8f5&scoped=true&"
import script from "./Spacer.js?vue&type=script&lang=js&"
export * from "./Spacer.js?vue&type=script&lang=js&"
import style0 from "./Spacer.scss?vue&type=style&index=0&id=78f7a8f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7a8f5",
  null
  
)

export default component.exports